/* ============================================
   WATERCRAFT THEME - JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Utility --- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function on(el, evt, fn, opts) { el && el.addEventListener(evt, fn, opts); }
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  }

  /* ============================
     HERO SLIDESHOW
     ============================ */
  function initSlideshow() {
    const slideshows = qsa('[data-slideshow]');
    slideshows.forEach(function(ss) {
      const slides = ss.querySelector('[data-slideshow-slides]');
      const dots = qsa('[data-slideshow-dot]', ss);
      const prevBtn = ss.querySelector('[data-slideshow-prev]');
      const nextBtn = ss.querySelector('[data-slideshow-next]');
      const total = slides ? slides.children.length : 0;
      let current = 0;
      let autoInterval = null;
      var autoDelay = parseInt(ss.dataset.slideshowDelay) || 5000;

      function goTo(idx) {
        current = ((idx % total) + total) % total;
        slides.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === current); });
      }

      on(prevBtn, 'click', function() { goTo(current - 1); resetAuto(); });
      on(nextBtn, 'click', function() { goTo(current + 1); resetAuto(); });
      dots.forEach(function(d, i) {
        on(d, 'click', function() { goTo(i); resetAuto(); });
      });

      function resetAuto() {
        clearInterval(autoInterval);
        autoInterval = setInterval(function() { goTo(current + 1); }, autoDelay);
      }

      if (total > 1) resetAuto();
    });
  }

  /* ============================
     MOBILE NAVIGATION
     ============================ */
  function initMobileNav() {
    var toggle = qs('[data-mobile-nav-toggle]');
    var nav = qs('[data-mobile-nav]');
    var close = qs('[data-mobile-nav-close]');
    var overlay = qs('[data-mobile-nav-overlay]');

    function open() { nav && nav.classList.add('is-active'); document.body.style.overflow = 'hidden'; }
    function shut() { nav && nav.classList.remove('is-active'); document.body.style.overflow = ''; }

    on(toggle, 'click', open);
    on(close, 'click', shut);
    on(overlay, 'click', shut);

    // Submenu toggles
    qsa('[data-mobile-submenu-toggle]').forEach(function(btn) {
      on(btn, 'click', function(e) {
        e.preventDefault();
        var list = btn.closest('.mobile-nav__item').querySelector('.mobile-nav__sublist');
        if (list) list.classList.toggle('is-open');
        btn.classList.toggle('is-open');
      });
    });
  }

  /* ============================
     CART DRAWER
     ============================ */
  function initCartDrawer() {
    var drawer = qs('[data-cart-drawer]');
    var overlay = qs('[data-cart-drawer-overlay]');
    var closeBtn = qs('[data-cart-drawer-close]');

    function openDrawer() {
      drawer && drawer.classList.add('is-active');
      overlay && overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer && drawer.classList.remove('is-active');
      overlay && overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    // Open on cart icon click
    qsa('[data-open-cart-drawer]').forEach(function(btn) {
      on(btn, 'click', function(e) { e.preventDefault(); openDrawer(); });
    });
    on(closeBtn, 'click', closeDrawer);
    on(overlay, 'click', closeDrawer);

    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;
  }

  /* ============================
     QUICK VIEW
     ============================ */
  function initQuickView() {
    var modal = qs('[data-quick-view]');
    var overlay = qs('[data-quick-view-overlay]');
    var closeBtn = qs('[data-quick-view-close]');
    var content = qs('[data-quick-view-content]');

    function closeModal() {
      modal && modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    on(closeBtn, 'click', closeModal);
    on(overlay, 'click', closeModal);

    // Delegate quick view opens
    on(document, 'click', function(e) {
      var btn = e.target.closest('[data-quick-view-trigger]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.dataset.quickViewTrigger;
      if (!url || !modal || !content) return;

      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      content.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:300px;"><div class="spinner"></div></div>';

      fetch(url + '?sections=product-quick-view')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data['product-quick-view']) {
            content.innerHTML = data['product-quick-view'];
            initQuickViewThumbs(content);
            initQuickViewQty(content);
            updateWishlistUI();
          } else {
            content.innerHTML = '<p style="padding:40px;text-align:center;">Unable to load product.</p>';
          }
        })
        .catch(function() {
          content.innerHTML = '<p style="padding:40px;text-align:center;">Unable to load product.</p>';
        });
    });
  }

  /* Quick View helpers */
  function initQuickViewThumbs(ctx) {
    qsa('[data-quick-view-thumb]', ctx).forEach(function(thumb) {
      on(thumb, 'click', function() {
        var mainImg = qs('.quick-view__image', ctx);
        if (mainImg) mainImg.src = thumb.dataset.quickViewThumb;
        qsa('[data-quick-view-thumb]', ctx).forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initQuickViewQty(ctx) {
    qsa('[data-qty-minus]', ctx).forEach(function(btn) {
      on(btn, 'click', function() {
        var input = btn.parentElement.querySelector('input');
        if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
      });
    });
    qsa('[data-qty-plus]', ctx).forEach(function(btn) {
      on(btn, 'click', function() {
        var input = btn.parentElement.querySelector('input');
        if (input) input.value = parseInt(input.value) + 1;
      });
    });
  }

  /* ============================
     PRODUCT PAGE
     ============================ */
  function initProductPage() {
    // Thumbnail gallery
    qsa('[data-gallery-thumb]').forEach(function(thumb) {
      on(thumb, 'click', function() {
        var mainImg = qs('[data-gallery-main-img]');
        if (mainImg) mainImg.src = thumb.dataset.galleryThumb;
        qsa('[data-gallery-thumb]').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Tabs
    qsa('[data-tab-trigger]').forEach(function(tab) {
      on(tab, 'click', function() {
        var target = tab.dataset.tabTrigger;
        var container = tab.closest('[data-tabs]');
        qsa('[data-tab-trigger]', container).forEach(function(t) { t.classList.remove('is-active'); });
        qsa('[data-tab-panel]', container).forEach(function(p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = qs('[data-tab-panel="' + target + '"]', container);
        if (panel) panel.classList.add('is-active');
      });
    });

    // Quantity buttons
    qsa('[data-qty-minus]').forEach(function(btn) {
      on(btn, 'click', function() {
        var input = btn.parentElement.querySelector('input');
        if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
      });
    });
    qsa('[data-qty-plus]').forEach(function(btn) {
      on(btn, 'click', function() {
        var input = btn.parentElement.querySelector('input');
        if (input) input.value = parseInt(input.value) + 1;
      });
    });

    // Variant selection
    qsa('[data-variant-option]').forEach(function(opt) {
      on(opt, 'click', function() {
        qsa('[data-variant-option]', opt.closest('.variant-group__options')).forEach(function(o) {
          o.classList.remove('is-active');
        });
        opt.classList.add('is-active');
      });
    });
  }

  /* ============================
     ADD TO CART (AJAX)
     ============================ */
  function initAddToCart() {
    on(document, 'submit', function(e) {
      var form = e.target.closest('[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[data-add-to-cart-btn]');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (btn) { btn.textContent = 'Added!'; }
        updateCartCount();
        if (window.openCartDrawer) window.openCartDrawer();
        updateCartDrawer();
        setTimeout(function() { if (btn) { btn.textContent = origText; btn.disabled = false; } }, 2000);
      })
      .catch(function() {
        if (btn) { btn.textContent = 'Error'; btn.disabled = false; }
        setTimeout(function() { if (btn) btn.textContent = origText; }, 2000);
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        qsa('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  function updateCartDrawer() {
    var drawerItems = qs('[data-cart-drawer-items]');
    var drawerFooter = qs('[data-cart-drawer-footer]');
    if (!drawerItems) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) {
          drawerItems.innerHTML = '<div class="cart-drawer__empty"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/></svg><p>Your cart is empty</p></div>';
          if (drawerFooter) drawerFooter.style.display = 'none';
          return;
        }

        var html = '';
        cart.items.forEach(function(item) {
          html += '<div class="cart-item" style="grid-template-columns:auto 1fr auto; padding:12px 0;">';
          html += '<div class="cart-item__image"><img src="' + (item.image || '') + '" alt="' + item.title + '"></div>';
          html += '<div><div class="cart-item__name">' + item.title + '</div>';
          html += '<div class="cart-item__variant">' + (item.variant_title || '') + '</div>';
          html += '<div style="margin-top:4px;font-weight:600;">' + formatMoney(item.final_line_price) + '</div></div>';
          html += '<button class="cart-item__remove" onclick="removeCartItem(' + item.key + ')">&#x2715;</button>';
          html += '</div>';
        });
        drawerItems.innerHTML = html;

        if (drawerFooter) {
          drawerFooter.style.display = 'block';
          var footerTotal = qs('[data-cart-drawer-total]');
          if (footerTotal) footerTotal.textContent = formatMoney(cart.total_price);
        }
      });
  }

  window.removeCartItem = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key.toString(), quantity: 0 })
    })
    .then(function() { updateCartCount(); updateCartDrawer(); });
  };

  /* ============================
     SCROLL TO TOP
     ============================ */
  function initScrollToTop() {
    var btn = qs('[data-scroll-top]');
    if (!btn) return;

    window.addEventListener('scroll', function() {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });

    on(btn, 'click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ============================
     COLLECTION FILTERS
     ============================ */
  function initCollectionFilters() {
    var toggle = qs('[data-filter-toggle]');
    var sidebar = qs('[data-filter-sidebar]');
    if (toggle && sidebar) {
      on(toggle, 'click', function() {
        sidebar.classList.toggle('is-open');
      });
    }

    // Filter group toggles
    qsa('[data-filter-group-toggle]').forEach(function(btn) {
      on(btn, 'click', function() {
        var options = btn.closest('.filter-group').querySelector('.filter-group__options');
        if (options) options.classList.toggle('is-collapsed');
      });
    });
  }

  /* ============================
     WISHLIST (localStorage)
     ============================ */
  var WISHLIST_KEY = 'watercraft_wishlist';

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      // Migrate old string-only format to objects
      return raw.map(function(item) {
        if (typeof item === 'string') return { id: item, handle: '' };
        return item;
      });
    } catch(e) { return []; }
  }
  function saveWishlist(list) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); }

  function findInWishlist(list, id) {
    var sid = String(id);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === sid) return i;
    }
    return -1;
  }

  function toggleWishlist(productId, handle) {
    var id = String(productId);
    var list = getWishlist();
    var idx = findInWishlist(list, id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({ id: id, handle: handle || '' });
    }
    saveWishlist(list);
    updateWishlistUI();
    updateWishlistPage();
  }

  function updateWishlistUI() {
    var list = getWishlist();
    var count = list.length;
    qsa('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    qsa('[data-wishlist-page-count]').forEach(function(el) {
      el.textContent = count === 1 ? '1 item' : count + ' items';
    });
    qsa('[data-wishlist-toggle]').forEach(function(btn) {
      var id = String(btn.dataset.wishlistToggle);
      var isWished = findInWishlist(list, id) > -1;
      btn.classList.toggle('is-wishlisted', isWished);
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', isWished ? 'currentColor' : 'none');
    });
  }

  on(document, 'click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleWishlist(btn.dataset.wishlistToggle, btn.dataset.productHandle || '');
  });

  /* ============================
     WISHLIST PAGE
     ============================ */
  // Resolve old-format items (ID only, no handle) by searching products.json
  function migrateOldWishlistItems(list) {
    var needsMigration = list.filter(function(item) { return !item.handle; });
    if (needsMigration.length === 0) return Promise.resolve(list);

    return fetch('/products.json?limit=250')
      .then(function(r) { return r.ok ? r.json() : { products: [] }; })
      .then(function(data) {
        var products = data.products || [];
        var updated = false;
        list.forEach(function(item) {
          if (!item.handle) {
            var match = products.find(function(p) { return String(p.id) === String(item.id); });
            if (match) {
              item.handle = match.handle;
              updated = true;
            }
          }
        });
        if (updated) saveWishlist(list);
        return list;
      })
      .catch(function() { return list; });
  }

  function initWishlistPage() {
    var grid = qs('[data-wishlist-grid]');
    if (!grid) return;

    var emptyState = qs('[data-wishlist-empty]');
    var loading = qs('[data-wishlist-loading]');
    var list = getWishlist();

    if (list.length === 0) {
      if (loading) loading.style.display = 'none';
      grid.style.display = 'none';
      if (emptyState) emptyState.style.display = 'flex';
      return;
    }

    // Migrate old items then render
    migrateOldWishlistItems(list).then(function(migratedList) {
      var validItems = migratedList.filter(function(item) { return item.handle && item.handle.length > 0; });

      if (validItems.length === 0) {
        if (loading) loading.style.display = 'none';
        grid.style.display = 'none';
        if (emptyState) emptyState.style.display = 'flex';
        return;
      }

      renderWishlistItems(validItems, grid, emptyState, loading);
    });
  }

  function renderWishlistItems(validItems, grid, emptyState, loading) {
    // Fetch all product data
    var fetches = validItems.map(function(item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    });

    Promise.all(fetches).then(function(products) {
      if (loading) loading.style.display = 'none';

      var html = '';
      products.forEach(function(product) {
        if (!product) return;

        var variant = product.variants[0];
        var price = formatMoney(variant.price);
        var comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price) : '';
        var imgSrc = product.featured_image
          ? product.featured_image.replace(/\.([^.]+)$/, '_480x.$1')
          : '';
        var available = product.available;

        html += '<div class="wishlist-item" data-wishlist-item="' + product.id + '">';
        html += '  <div class="product-card">';
        html += '    <div class="product-card__image-wrap">';
        if (imgSrc) {
          html += '      <img src="' + imgSrc + '" alt="' + product.title + '" class="product-card__image" loading="lazy" width="480" height="480">';
        } else {
          html += '      <div style="aspect-ratio:1;background:#e2e8f0;display:flex;align-items:center;justify-content:center;">';
          html += '        <svg width="48" height="48" fill="none" stroke="#94a3b8" stroke-width="1" viewBox="0 0 24 24"><path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"/></svg>';
          html += '      </div>';
        }
        if (!available) {
          html += '      <div class="product-card__badges"><span class="badge badge--soldout">Sold Out</span></div>';
        }
        html += '      <button class="wishlist-item__remove" data-wishlist-remove="' + product.id + '" data-product-handle="' + product.handle + '" aria-label="Remove from wishlist">';
        html += '        <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>';
        html += '      </button>';
        html += '    </div>';
        html += '    <div class="product-card__body">';
        if (product.vendor) {
          html += '      <div class="product-card__vendor">' + product.vendor + '</div>';
        }
        html += '      <h3 class="product-card__title"><a href="/products/' + product.handle + '">' + product.title + '</a></h3>';
        html += '      <div class="product-card__price">';
        html += '        <span class="product-card__price-current">' + price + '</span>';
        if (comparePrice) {
          html += '        <span class="product-card__price-compare">' + comparePrice + '</span>';
        }
        html += '      </div>';
        html += '      <div class="wishlist-item__actions">';
        if (available) {
          html += '        <a href="/products/' + product.handle + '" class="btn btn--primary btn--sm wishlist-item__view-btn">View Product</a>';
        } else {
          html += '        <span class="btn btn--outline btn--sm" disabled>Sold Out</span>';
        }
        html += '      </div>';
        html += '    </div>';
        html += '  </div>';
        html += '</div>';
      });

      if (html) {
        grid.innerHTML = html;
        grid.style.display = '';
      } else {
        grid.style.display = 'none';
        if (emptyState) emptyState.style.display = 'flex';
      }
    });
  }

  function updateWishlistPage() {
    var grid = qs('[data-wishlist-grid]');
    if (!grid) return;
    var list = getWishlist();
    var emptyState = qs('[data-wishlist-empty]');
    if (list.length === 0) {
      grid.style.display = 'none';
      if (emptyState) emptyState.style.display = 'flex';
    }
  }

  // Remove from wishlist on wishlist page
  on(document, 'click', function(e) {
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.wishlistRemove;
    var item = btn.closest('[data-wishlist-item]');
    if (item) {
      item.style.transition = 'opacity 0.3s, transform 0.3s';
      item.style.opacity = '0';
      item.style.transform = 'scale(0.95)';
      setTimeout(function() {
        item.remove();
        toggleWishlist(id, btn.dataset.productHandle || '');
      }, 300);
    } else {
      toggleWishlist(id, btn.dataset.productHandle || '');
    }
  });

  /* ============================
     PREDICTIVE SEARCH
     ============================ */
  function initPredictiveSearch() {
    var input = qs('[data-predictive-search]');
    var results = qs('[data-predictive-results]');
    if (!input || !results) return;

    var debounceTimer;
    on(input, 'input', function() {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) { results.style.display = 'none'; return; }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (products.length === 0) { results.style.display = 'none'; return; }

            var html = '';
            products.forEach(function(p) {
              html += '<a href="' + p.url + '" class="predictive-result">';
              html += '<img src="' + (p.image || '') + '" alt="" class="predictive-result__img">';
              html += '<div class="predictive-result__info"><div class="predictive-result__title">' + p.title + '</div>';
              html += '<div class="predictive-result__price">' + formatMoney(p.price) + '</div></div>';
              html += '</a>';
            });
            results.innerHTML = html;
            results.style.display = 'block';
          });
      }, 300);
    });

    // Close on click outside
    on(document, 'click', function(e) {
      if (!e.target.closest('[data-predictive-search]') && !e.target.closest('[data-predictive-results]')) {
        results.style.display = 'none';
      }
    });
  }

  /* ============================
     INIT
     ============================ */
  document.addEventListener('DOMContentLoaded', function() {
    initSlideshow();
    initMobileNav();
    initCartDrawer();
    initQuickView();
    initProductPage();
    initAddToCart();
    initScrollToTop();
    initCollectionFilters();
    initPredictiveSearch();
    updateWishlistUI();
    updateCartCount();
    initWishlistPage();
  });

})();
